import RoutePath from "routes/utils";

export default {
  timezone: new RoutePath('/api/account/timezones/'),
  current_user: new RoutePath('/api/account/current-user/'),
}
